import React, { useState } from 'react';
import axios from 'axios';

import './EditPage.css';

import backIcon from './../../image/back.png';

const EditPage = ({ setCurrentPage, selectedCategory }) => {
    const [nameRu, setNameRu] = useState(selectedCategory.nameRu || '');
    const [nameEn, setNameEn] = useState(selectedCategory.nameEn || '');

    //сохранить изменения категории
    const handleSaveClick = async () => {
        try {
            const response = await axios.post(
                'https://mepointserver.ru/manage/category/save',
                {
                    id: selectedCategory.id,
                    nameEn: nameEn,
                    nameRu: nameRu,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );
            if (response.data.success) {
                console.log('Изменения сохранены');
                setCurrentPage('Menu');
            }
        } catch (error) {
            console.error('Ошибка сохранения категории ', error);
        }
    };

    // клик назад
    const handleBackClick = () => {
        setCurrentPage('Menu');
    };

    return (
        <div className='edit__wrapper'>
            <div className='edit__back' onClick={handleBackClick}>
                <img src={backIcon} alt='back' />
            </div>
            <h1 className='edit__title'>Редактировать категорию</h1>
            <div className='edit__items'>
                <div className='edit__item_name'>
                    <h3>Название (Ru)</h3>
                    <input
                        type='text'
                        value={nameRu}
                        onChange={(e) => setNameRu(e.target.value)}
                    />
                </div>

                <div className='edit__item_name'>
                    <h3>Название (En)</h3>
                    <input
                        type='text'
                        value={nameEn}
                        onChange={(e) => setNameEn(e.target.value)}
                    />
                </div>
            </div>
            <div className='edit__btn' onClick={handleSaveClick}>
                Сохранить
            </div>
        </div>
    );
};

export default EditPage;
